const HaitiSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111571)">
      <path
        d="M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20C0 8.95437 20 0 20 0C20 0 40 8.95437 40 20Z"
        fill="#A2001D"
      />
      <path d="M0 20C0 8.95437 8.95437 0 20 0C31.0456 0 40 8.95437 40 20" fill="#0052B4" />
      <path
        d="M26.9564 25.218L19.9999 24.3484L13.0435 25.218V14.7832H26.9564V25.218Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9998 24.3482C21.9208 24.3482 23.478 22.7909 23.478 20.8699C23.478 18.9489 21.9208 17.3916 19.9998 17.3916C18.0788 17.3916 16.5215 18.9489 16.5215 20.8699C16.5215 22.7909 18.0788 24.3482 19.9998 24.3482Z"
        fill="#0052B4"
      />
      <path
        d="M19.9999 22.6082C20.9604 22.6082 21.739 21.8295 21.739 20.869C21.739 19.9085 20.9604 19.1299 19.9999 19.1299C19.0394 19.1299 18.2607 19.9085 18.2607 20.869C18.2607 21.8295 19.0394 22.6082 19.9999 22.6082Z"
        fill="#A2001D"
      />
      <path d="M17.3916 16.5215H22.6089L20.0003 19.1302L17.3916 16.5215Z" fill="#6DA544" />
      <path d="M19.1309 18.2598H20.87V23.4772H19.1309V18.2598Z" fill="#FFDA44" />
      <path d="M22.7825 22.9561H17.2172L13.0435 25.217H26.9564L22.7825 22.9561Z" fill="#6DA544" />
    </g>
    <defs>
      <clipPath id="clip0_4152_111571">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default HaitiSvg;
